<template>
  <Form style="line-height:32px"
        :model="formdata"
        :label-width="120"
        inline
        ref="form">
    <FormItem :label="$t('global.common.notes',{defaultValue:'备注'})"
              style="width:90%"
              :rules='required'
              prop="remark">
      <Input v-model="formdata.remark"
             :rows="3"
             type="textarea" />
    </FormItem>
    <footer class="text-right">
      <Button type="primary"
              @click="submit">{{$t('global.common.save',{defaultValue:'保存'})}}</Button>
      <Button class="margin-left-10"
              @click="cancel">{{$t('global.common.cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </Form>
</template>
<script>
import {
  HttpAddRemark
} from '@/service/boss/distribution'
export default {
  props: ['activeids'],
  data () {
    return {
      loading: false,
      formdata: {
        remark: "",
      },
      required: [{
        required: true,
        message: this.$t("global.common.fill_requiredd", { defaultValue: '该信息不能为空,请填写' })
      }],
    }
  },
  methods: {
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      let data = await this.$refs['form'].validate();
      if (!data) return;
      this.loading = true;
      HttpAddRemark({
        deliverOrderIds: this.activeids,
        remark: this.formdata.remark
      }).then(res => {
        this.$Message.success(res.message);
        this.cancel();
        this.$emit('on-update');
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
